// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDoubleRightOutlinedSvg from "@fishx/icons-svg/es/asn/PDoubleRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PDoubleRightOutlined = function PDoubleRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDoubleRightOutlinedSvg
  }));
};

PDoubleRightOutlined.displayName = 'PDoubleRightOutlined';
export default React.forwardRef(PDoubleRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDoubleRightOutlined.js
// module id = 3342
// module chunks = 0